import { Pipe, PipeTransform } from '@angular/core';
import { ConfigService, Country } from '../services/config.service';

@Pipe({
  name: 'scrConfig',
  pure: false
})
export class ConfigPipe implements PipeTransform {

  private outputValue?: string | boolean | string[] = undefined;

  constructor(private svc: ConfigService) {
  }

  transform(value: string | string[] | boolean | undefined, cfgType: string): string | string[] | boolean | undefined {
    this.outputValue = value;
    switch (cfgType) {
      case 'country':
        this.svc.getCountries().subscribe((countries: Country[]) => {
          if (typeof value === 'string') {
            this.outputValue = countries.find((c:Country) => c.country === value)?.countryName;
          }
          else if (Array.isArray(value)) {
            this.outputValue = value.map(s => {
              return countries.find((c:Country) => c.country === s)?.countryName;
            }).join(', ');
          }
        });
        break;
      case 'role': {
        const role = this.svc.getSdRoles().find(r => r.value === value);
        if (role) {
          this.outputValue = role.label;
        }
        break;
      }
      case 'autorenew': {
        this.outputValue = value ? 'Enrolled' : 'Not Enrolled';
        break;
      }
      case 'entityType': {
        this.outputValue = (value === 'Brand') ? 'Brand Client' : 'Content Provider';
        break;
      }
      default:
        console.warn('unprocessed config type ' + cfgType);
        break;
    }
    return this.outputValue;
  }
}
